var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.14375C0 0.512073 0.486531 0 1.0867 0H14.8515C15.4517 0 15.9382 0.512073 15.9382 1.14375C15.9382 1.77542 15.4517 2.2875 14.8515 2.2875H1.0867C0.486531 2.2875 0 1.77542 0 1.14375Z",
    fill: "#B0BCC1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.09999C0 5.46831 0.486531 4.95624 1.0867 4.95624H9.78027C10.3804 4.95624 10.867 5.46831 10.867 6.09999C10.867 6.73166 10.3804 7.24374 9.78027 7.24374H1.0867C0.486531 7.24374 0 6.73166 0 6.09999Z",
    fill: "#B0BCC1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.4375C0 10.8058 0.486531 10.2937 1.0867 10.2937H6.15795C6.75811 10.2937 7.24464 10.8058 7.24464 11.4375C7.24464 12.0692 6.75811 12.5812 6.15795 12.5812H1.0867C0.486531 12.5812 0 12.0692 0 11.4375Z",
    fill: "#B0BCC1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9017 16.3989C14.3016 16.4018 13.8128 15.8921 13.81 15.2604L13.7698 6.11055C13.7671 5.47888 14.2513 4.96445 14.8515 4.96153C15.4517 4.95861 15.9404 5.46831 15.9432 6.09997L15.9834 15.2499C15.9862 15.8815 15.5019 16.396 14.9017 16.3989Z",
    fill: "#B0BCC1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3143 11.9995C10.7387 11.5529 11.4267 11.5529 11.8511 11.9995L15.6972 16.0475C16.1215 16.4942 16.1215 17.2183 15.6972 17.665C15.2728 18.1117 14.5847 18.1117 14.1603 17.665L10.3143 13.617C9.88991 13.1704 9.88991 12.4462 10.3143 11.9995Z",
    fill: "#B0BCC1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6817 11.9995C19.2573 11.5529 18.5693 11.5529 18.1449 11.9995L14.2988 16.0475C13.8745 16.4942 13.8745 17.2183 14.2988 17.665C14.7232 18.1117 15.4113 18.1117 15.8357 17.665L19.6817 13.617C20.1061 13.1704 20.1061 12.4462 19.6817 11.9995Z",
    fill: "#B0BCC1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDisabled);
export default __webpack_public_path__ + "static/media/sort_disabled.86e40c0506b830962e2150acc553583d.svg";
export { ForwardRef as ReactComponent };